import QRCode from 'qrcode';

$(document).on('click', '#amSpotShowMissionQR', async () => {
  $('#amMissionQR').removeAttr('src');

  const spot = window.Gdata.CurrentSpots.dic[window.SpotEditId || ''];
  if (!spot || !spot.map_id) {
    return;
  }

  const mapData = window.Gdata.CurrentMap.ori[0];
  let milestone = typeof mapData.milestone !== 'undefined' ? mapData.milestone : '';
  let encodeTitle = encodeURIComponent(mapData.title);
  const encodedString = encodeURIComponent(btoa(`${spot.map_id},${spot._id},${milestone},${encodeTitle}`));
  // const encodedString = encodeURIComponent(btoa(`${spot.map_id},${spot._id},${milestone},${mapData.title}`));
  const base64 = await QRCode.toDataURL(`${window.AS.ALIAS_MAP_MISSION_QR_URL}/?t=${encodedString}`, {
    margin: 0,
    width: 300,
  });

  $('#amMissionQR').attr('src', base64);
});

$(document).on('click', '#amMissionDownloadQR', () => {
  const spot = window.Gdata.CurrentSpots.dic[window.SpotEditId || ''];
  if (!spot || !spot.map_id) {
    return;
  }

  const downloadLink = document.createElement('a');
  downloadLink.href = String($('#amMissionQR').attr('src'));
  downloadLink.download = `ミッションQRコード（${spot.title}）.png`;
  downloadLink.click();
});
